
import { Vue, Component, Watch } from 'vue-property-decorator';
import { warkLabel } from '@/models/wark';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';
import moment from 'moment';
import { AuthEnum } from '@/services/permission.service';

@Component({})
export default class ListRechargeStores extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  moment = moment;
  data: any = [];

  AuthEnum = AuthEnum;

  typeChild: string | null = localStorage.getItem('typeChild');

  columns = [
    ...warkLabel.init('ListRechargeStores').titleColumns,
  ];
  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };

  filterForm: any = {
    month: '',
    group_id: undefined,
    dept_id: undefined,
    department: '',
    group: '',
    name: '',
    goods_name: '',
    poi: '',
    shop_name: '',
    agent_name: '',
  };

  module: any = '';


  dept_list: any = [];

  group_list: any = [];

  @Watch('$route.query')
  onRouteChange() {
    const { page, pageSize, module, month, group_id, dept_id, name, goods_name, poi, shop_name, agent_name } = this.$route.query;
    const queryParams: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      module: module || '',
    };
    this.module = module || '';
    if (month) {
      queryParams.month = month;
      this.filterForm.month = month;
    }
    if (group_id) {
      queryParams.group_id = group_id;
      this.filterForm.group_id = +group_id;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
      this.filterForm.dept_id = +dept_id;
    }
    if (name) {
      queryParams.name = name;
      this.filterForm.name = name;
    }
    if (goods_name) {
      queryParams.goods_name = goods_name;
      this.filterForm.goods_name = goods_name;
    }
    if (poi) {
      queryParams.poi = poi;
      this.filterForm.poi = poi;
    }
    if (shop_name) {
      queryParams.shop_name = shop_name;
      this.filterForm.shop_name = shop_name;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
      this.filterForm.agent_name = agent_name;
    }
    this.pagination.current = +page || 1;
    this.pagination.pageSize = +pageSize || 10;
    // this.getQueryParams();
    this.getList(queryParams);
  }
  changeMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    const _d = `${year}-${month}`;
    this.filterForm.month = _d;
  }


  async exportData() {
    const queryParams: any = {
      module: this.module,
      export: 1,
    };
    await this.workbenchesService.getQuickEntranceExport(queryParams, '推广通充值门店列表');
  }

  onShowSizeChange(page: any, pageSize: any) {
    this.pagination.pageSize = +pageSize;
    this.pagination.current = 1;
    this.getQuote();
  }
  async getList(val: any) {
    const res = await this.workbenchesService.getQuickEntrance(val, this.$el);
    this.data = res.list;
    this.fun(res.list);
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }

  fun(data: any) {
    const dataSource = data;
    const _data = data.map((item: any) => dataSourceForEach(item));
    function dataSourceForEach(item: any) {
      const _item: any = item;
      let dept_shop_num = 0;
      dataSource.forEach((rem: any) => {
        if (item.dept_id === rem.dept_id) {
          dept_shop_num++;
        }
      });
      let group_shop_num = 0;
      dataSource.forEach((rem: any) => {
        if (item.group_id === rem.group_id) {
          group_shop_num++;
        }
      });
      let shop_num = 0;
      dataSource.forEach((rem: any) => {
        if (item.user_id === rem.user_id) {
          shop_num++;
        }
      });

      _item.dept_shop_num = dept_shop_num;
      _item.group_shop_num = group_shop_num;
      _item.shop_num = shop_num;
      return _item;
    }
    this.data = _data;
  }


  onChange(page: any, pageSize: any) {
    this.pagination.current = +page;
    this.pagination.pageSize = pageSize;
    this.getQuote();
  }

  reset() {
    this.filterForm = {
      month: '',
      group_id: undefined,
      dept_id: undefined,
      department: '',
      group: '',
      name: '',
      goods_name: '',
      poi: '',
      shop_name: '',
      agent_name: '',
    };
    const { pageSize } = this.pagination;
    const queryParams: any = {
      page: 1,
      pageSize,
      module: this.module,
    };
    queryParams.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: queryParams,
    });
  }

  search() {
    this.pagination.current = 1;
    this.getQuote();
  }

  getQuote() {
    const { month, group_id, dept_id, name, goods_name, poi, shop_name, agent_name } = this.filterForm;
    const { current, pageSize } = this.pagination;
    const queryParams: any = {
      page: current,
      pageSize,
      module: this.module,
    };
    if (month) {
      queryParams.month = month;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (name) {
      queryParams.name = name;
    }
    if (goods_name) {
      queryParams.goods_name = goods_name;
    }
    if (poi) {
      queryParams.poi = poi;
    }
    if (shop_name) {
      queryParams.shop_name = shop_name;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    queryParams.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: queryParams,
    });
  }

  mounted() {
    this.onRouteChange();
    this.getDeptInfo();
    this.changeColumns(this.typeChild!);
  }

  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }
  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.filterForm.group_id = undefined;
  }
  refresh() { }

  changeColumns(val: string) {
    switch (val) {
      case 'director': // 总监
        this.columns = [
          ...warkLabel.init('ListRechargeStores').department,
          ...warkLabel.init('ListRechargeStores').groupLeader,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
      case 'assistantDirector': // 助理
        this.columns = [
          ...warkLabel.init('ListRechargeStores').department,
          ...warkLabel.init('ListRechargeStores').groupLeader,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
      case 'kaTeamLeader': // 部长
        this.columns = [
          ...warkLabel.init('ListRechargeStores').department,
          ...warkLabel.init('ListRechargeStores').groupLeader,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
      case 'ordinaryTeamMinister': // 部长
        this.columns = [
          ...warkLabel.init('ListRechargeStores').department,
          ...warkLabel.init('ListRechargeStores').groupLeader,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
      case 'kaTeamMinister': // 组长
        this.columns = [
          ...warkLabel.init('ListRechargeStores').supplementGroupLeader,
          ...warkLabel.init('ListRechargeStores').groupLeader,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
      case 'ordinaryTeamLeader': // 组长
        this.columns = [
          ...warkLabel.init('ListRechargeStores').supplementGroupLeader,
          ...warkLabel.init('ListRechargeStores').groupLeader,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
      default: // 普通
        this.columns = [
          ...warkLabel.init('ListRechargeStores').supplementTitleColumns,
          ...warkLabel.init('ListRechargeStores').titleColumns,
        ];
        break;
    }

    const obj: any = {
      dept_name: 'dept_id',
      dept_manager: 'dept_id',
      dept_shop_num: 'dept_id',
      group_manager: 'group_id',
      group_shop_num: 'group_id',
      group_name: 'group_id',
      agent_name: 'user_id',
      shop_num: 'user_id',
    };
    this.columns.forEach((res: any) => {
      if (Object.prototype.hasOwnProperty.call(obj, res.dataIndex)) {
        res.customRender = (text: any, row: any, index: any) => {
          return this.customRender(text, row, index, obj[res.dataIndex]);
        };
      }
    });
  }
  customRender(text: any, row: any, index: any, column: any) {
    const prevRow: any = this.data[index - 1];
    if (prevRow && prevRow[column] === row[column]) {
      return {
        children: text,
        attrs: {
          rowSpan: 0,
        },
      };
    }
    let rowSpan = 1;
    const _i: number = index;
    for (let i = _i + 1; i < this.data.length; i++) {
      const currentRow: any = this.data[i];
      if (currentRow[column] === row[column]) {
        rowSpan++;
      } else {
        break;
      }
    }
    return {
      children: text,
      attrs: {
        rowSpan,
      },
    };
  }

  back() {
    this.$router.push({ name: 'workbenches.index' });
  }
}
